function blankToNull() {
    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
          ngModel.$parsers.push(function(value) {
            return value === '' ? null : value;
          });
        }
      };
};

export { blankToNull }
